// extracted by mini-css-extract-plugin
module.exports = {"Panel":"style_Panel__WJIUC","appearing":"style_appearing__26H6p"};